import { useCallback } from "react";

import { HStack } from "@chakra-ui/react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

import { NavBar } from "@app/navigation/ui/nav-bar";
import { TotpResetEmailPageConnector } from "@pages/totp-reset/totp-reset-email-page-connector";
import { TotpResetPageConnector } from "@pages/totp-reset/totp-reset-page-connector";
import { PageTemplate } from "@shared/ui/templates/page-template";
import { LanguageToggleConnector } from "@widgets/language-toggle";
import { HelpBox } from "@widgets/profile-avatar/ui/help-box";

import { Route as TwoFaVerifyRoute } from "./_private/two-fa-verify";
import { totpResetSearchMessages } from "./messages";

export const totpResetSearchSchema = z.object({
  resetCode: z
    .string({ message: totpResetSearchMessages.type.id })
    .min(1, totpResetSearchMessages.required.id),
});

export const Route = createFileRoute("/totp-reset")({
  component: RouteComponent,
  loader: async ({ context }) => {
    const isAuthenticated = context.getAuthStatus();
    return { isAuthenticated };
  },
  validateSearch: zodValidator(totpResetSearchSchema),
});

function RouteComponent() {
  const { isAuthenticated } = Route.useLoaderData();
  const { resetCode } = Route.useSearch();

  const navigate = useNavigate();

  const handleGoHome = useCallback(async () => {
    await navigate({
      to: "/",
    });
  }, [navigate]);

  const handleGoAuthenticator = useCallback(async () => {
    await navigate({
      replace: true,
      search: { kind: "authenticator" },
      to: TwoFaVerifyRoute.fullPath,
    });
  }, [navigate]);

  return (
    <PageTemplate
      navigationSlot={isAuthenticated ? <NavBar /> : undefined}
      profileSlot={
        <HStack>
          <LanguageToggleConnector />
          <HelpBox email="segunadebayo@mail.com" />
        </HStack>
      }
    >
      {isAuthenticated && (
        <TotpResetPageConnector
          code={resetCode}
          onGoHome={handleGoAuthenticator}
        />
      )}
      {!isAuthenticated && (
        <TotpResetEmailPageConnector code={resetCode} onGoHome={handleGoHome} />
      )}
    </PageTemplate>
  );
}
